import React, { useEffect, useState } from 'react';
import { useNotify } from 'react-admin';
import { GetAppRounded } from '@material-ui/icons';
import { CustomFilter } from '@/components/Global';
import { ParseInventoryList } from '@/actions/ParseData';
import { noScroll, removeNoScroll } from '@/actions/Helper';
import { useHistory } from 'react-router-dom';
import {
  getInventory,
  delInventory,
  upInventory,
  importInventory,
  exportInventory,
  delContainer,
  delContainerLoad,
  getTableList,
  deleteAllDroppedContainersApi,
  deleteAllLoadContainersApi,
  SaveData,
  getInventoryLoad,
  addLoadContainer,
  updateInventoryLoadSslSpec,
  SaveApiResMessage,
} from '@/actions';
import Add from './Add';
import List from './List';
import Edit from './Edit';
import styles from './styles';
import Pagination from '@/components/pagination';
import { useSelector } from 'react-redux';
import Options from '@/components/Global/Options';
import { formatDateTimeToUTC } from '@/ctUtlis/formatDate';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import PageContainerTabs from '@/components/PageContainerTabs';
import Modal from '@/ctComponents/Modal';
import PageContainer from '@/components/PageContainerAB/pageContainer';
import AddButton from '@/components/AddButton';
import IconButton from '@/ctComponents/IconButton';
import LoadingV2 from '@/components/Loading';
import SearchContainer from '../Appointments/SearchContainer';
import CustomBadge from '@/components/CustomBadge';

export default (props) => {
  const history = useHistory();
  const Sizes = useSelector((state) => state.reducer.size);
  const SSLs = useSelector((state) => state.reducer.ssl);
  const [tableType, setTableType] = useState('inventoryTable');
  const [openAdd, setOpenAdd] = useState(false);
  const cls = styles();
  const notify = useNotify();
  const [state, setState] = React.useState({
    edit: null,
    appointment: null,
    appointmentSet: null,
    file: null,
  });
  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    pages: [],
  });
  const tabParams = useParams();
  const [tableTheadTitle, settableTheadTitle] = React.useState([]);
  const [containerAppointments, setContainerAppointments] = React.useState();
  const [activeTab, setActiveTab] = useState(tabParams.tab || 'dropped');
  const mainToggleButtonRef = React.useRef(null);
  const getInventoryTableHeadList = () => {
    setLoading(true);
    if (activeTab === 'dropped') {
      getTableList('inventoryTableDropped')
        .then((res) => {
          if (res.data?.settings?.data) {
            settableTheadTitle(res.data?.settings?.data);
          } else {
            settableTheadTitle([
              // { label: '#', flex: 0.4, "show":  true  },
              { label: 'Size', flex: 0.6, show: true, object: 'size' },
              { label: 'SSL', flex: 0.7, show: true, object: 'ssl' },
              {
                label: 'Container #',
                flex: 0.9,
                show: true,
                object: 'name',
                hasLink: true,
              },
              {
                label: 'Chassis #',
                flex: 0.7,
                show: true,
                object: 'chases',
              },
              {
                label: 'Gated Out',
                flex: 0.9,
                show: true,
                object: 'gated_out',
              },
              {
                label: 'Gated In',
                flex: 0.9,
                show: true,
                object: 'gated_in',
              },
              { label: 'Empty Location', flex: 0.7, show: true, object: 'loc' },
              {
                label: 'Return Appointment',
                flex: 1.8,
                show: true,
                object: 'return_appointment',
              },
              {
                label: 'Single Transaction',
                flex: 0.9,
                show: true,
                object: 'return_terminals',
              },
              {
                label: 'Dual Only Transaction',
                flex: 0.9,
                show: true,
                object: 'return_dual_terminals',
              },
              { label: 'LFD', flex: 0.7, show: true, object: 'last_free_day' },
              {
                label: 'Est. PerDiem',
                flex: 0.7,
                show: true,
                object: 'est_per_diem',
              },
              // { label: 'Disputable Days', flex: 0.7 , "show":  true, object: '' },
              // { label: 'Disputable Amount', flex: 0.7 , "show":  true, object: '' },
              {
                label: 'Chassis Type',
                flex: 0.6,
                show: true,
                object: 'own_chases',
              },
              {
                label: 'Available Date',
                flex: 0.9,
                show: false,
                object: 'date',
              },
              {
                label: 'Last Import',
                flex: 0.9,
                show: false,
                object: 'added_date',
              },
              {
                label: 'Last Update',
                flex: 0.9,
                show: true,
                object: 'last_update',
              },
              // { label: 'Action', flex: 1.3 , "show":  true, object: '' },
            ]);
          }
          setLoading(false);
        })
        .catch((err) => {
          // notify(err, 'warning');
          SaveApiResMessage({
            title: 'Error',
            message: err,
            mode: 'warning',
          });
          setLoading(false);
        });
    } else {
      getTableList('inventoryTable')
        .then((res) => {
          if (res.data?.settings?.data) {
            settableTheadTitle(res.data?.settings?.data);
          } else {
            settableTheadTitle([
              // { label: '#', flex: 0.4, "show":  true  },
              { label: 'Size', flex: 0.6, show: true, object: 'size' },
              { label: 'SSL', flex: 0.7, show: true, object: 'ssl' },
              {
                label: 'Container #',
                flex: 0.9,
                show: true,
                object: 'name',
                hasLink: true,
              },
              {
                label: 'Chassis #',
                flex: 0.7,
                show: false,
                object: 'chases',
              },
              {
                label: 'Pickup Appointment',
                flex: 1.3,
                show: true,
                object: 'pickup_appointment',
              },
              {
                label: 'Gated Out',
                flex: 0.9,
                show: true,
                object: 'gated_out',
              },
              {
                label: 'Gated In',
                flex: 0.9,
                show: true,
                object: 'gated_in',
              },
              {
                label: 'Empty Location',
                flex: 0.7,
                show: false,
                object: 'loc',
              },
              {
                label: 'Return Appointment',
                flex: 1.8,
                show: true,
                object: 'return_appointment',
              },
              {
                label: 'Single Transaction',
                flex: 0.7,
                show: true,
                object: 'return_terminals',
              },
              {
                label: 'Dual Only Transaction',
                flex: 0.7,
                show: true,
                object: 'return_dual_terminals',
              },
              { label: 'LFD', flex: 0.7, show: true, object: 'last_free_day' },
              {
                label: 'Est. PerDiem',
                flex: 0.7,
                show: true,
                object: 'est_per_diem',
              },
              // { label: 'Disputable Days', flex: 0.7 , "show":  true, object: '' },
              // { label: 'Disputable Amount', flex: 0.7 , "show":  true, object: '' },
              {
                label: 'Chassis Type',
                flex: 0.6,
                show: false,
                object: 'own_chases',
              },
              {
                label: 'Available Date',
                flex: 0.9,
                show: false,
                object: 'date',
              },
              {
                label: 'Status',
                flex: 0.8,
                show: true,
                object: 'status',
              },
              {
                label: 'Last Check',
                flex: 0.9,
                show: false,
                object: 'added_date',
              },
              {
                label: 'Last Update',
                flex: 0.9,
                show: true,
                object: 'last_update',
              },
              // { label: 'Action', flex: 1.3 , "show":  true, object: '' },
            ]);
          }
          setLoading(false);
        })
        .catch((err) => {
          // notify(err, 'warning');
          SaveApiResMessage({
            title: 'Error',
            message: err,
            mode: 'warning',
          });
          setLoading(false);
        });
    }
  };

  const [loading, setLoading] = React.useState(true);
  const [DATA, setData] = React.useState([]);
  const [filteredData, setFilteredData] = React.useState([]);
  const [searchQuery, setSearchQuery] = React.useState('');
  const [filter, setFilter] = React.useState({
    open: false,
    DATA: [],
    appliedFilters: {},
  });

  // Handle search query changes
  React.useEffect(() => {
    if (DATA.length > 0) {
      const filteredData = filterContainersBySearch(DATA, searchQuery);
      setFilteredData(filteredData);
    }
  }, [searchQuery, DATA]);

  const [options, setOptions] = React.useState({
    open: false,
    DATA: [],
  });
  const [toggled, setToggled] = React.useState(false);

  // Delete all confirmation modal state
  const [showDeleteAllModal, setShowDeleteAllModal] = React.useState({
    show: false,
    deleteType: null, // 'dropped' or 'load'
  });
  const userMetas = useSelector((state) => state.reducer.user?.metas);

  const enable_appointments = userMetas?.enable_appointments?.value
    ? userMetas?.enable_appointments?.value
    : false;
  const enable_empty_tracking = userMetas?.enable_empty_tracking?.value
    ? userMetas?.enable_empty_tracking?.value
    : 'nis';
  const mptyTrackingEnable = enable_empty_tracking;
  const enable_loadout = userMetas?.enable_loadout?.value
    ? userMetas?.enable_loadout?.value
    : false;
  const loadoutEnable = enable_loadout;

  useEffect(() => {
    if (
      filter.appliedFilters &&
      Object.values(filter.appliedFilters).filter(Boolean).length > 0
    ) {
      let arr = DATA;

      // Handle different data structures
      if (filter.appliedFilters.size) {
        arr = arr.filter((i) => {
          const size =
            i.size ||
            i.specification?.size_type ||
            (i.containers && i.containers[0]?.size);
          return size === filter.appliedFilters.size.label;
        });
      }

      if (filter.appliedFilters.ssl) {
        arr = arr.filter((i) => {
          const ssl =
            i.ssl || i.company?.name || (i.containers && i.containers[0]?.ssl);

          return ssl === filter.appliedFilters.ssl.label;
        });
      }

      if (filter.appliedFilters.loc) {
        arr = arr.filter((i) => {
          // For dropped tab: i.loc
          // For load/all tab: i.return_terminals
          const loc =
            i.loc ||
            i.return_terminals ||
            (i.containers && i.containers[0]?.loc);
          return loc && filter.appliedFilters.loc.label.includes(loc);
        });
      }

      // if (form.date) arr = arr.filter((i) => i.size === form.size);
      if (filter.appliedFilters.num)
        arr = arr.filter((i) => i.num <= filter.appliedFilters.num);
      if (filter.appliedFilters.company)
        arr = arr.filter((i) => i.company <= filter.appliedFilters.company);

      // Store applied filters for indicator
      const appliedFilters = {};
      if (filter.appliedFilters.size)
        appliedFilters.size = filter.appliedFilters.size.label;
      if (filter.appliedFilters.ssl)
        appliedFilters.ssl = filter.appliedFilters.ssl.label;
      if (filter.appliedFilters.loc)
        appliedFilters.loc = filter.appliedFilters.loc.label;

      setFilter({ ...filter, DATA: arr, open: false });
    } else {
      // Reset to original data when no filters are applied
      setFilter({ ...filter, DATA: DATA, open: false });
    }
  }, [filter.appliedFilters]);

  const hasAppliedFilters = () => {
    return (
      filter.appliedFilters &&
      Object.entries(filter.appliedFilters).filter(([key, value]) => value)
        .length > 0
    );
  };

  // Search filtering function
  const filterContainersBySearch = (data, query) => {
    if (!query.trim()) return data;

    return data
      .map((item) => {
        if (item.containers) {
          // Filter containers within each item (for dropped tab)
          const filteredContainers = item.containers.filter(
            (container) =>
              container.name &&
              container.name.toLowerCase().includes(query.toLowerCase())
          );

          // Also check if the city (loc) matches the search query
          const cityMatches =
            item.loc && item.loc.toLowerCase().includes(query.toLowerCase());

          if (filteredContainers.length > 0 || cityMatches) {
            return {
              ...item,
              containers:
                filteredContainers.length > 0
                  ? filteredContainers
                  : item.containers,
            };
          }
          return null; // Remove items with no matching containers or city
        } else if (item.name) {
          // Filter individual containers (for all tab)
          if (item.name.toLowerCase().includes(query.toLowerCase())) {
            return item;
          }
          return null;
        }
        return item;
      })
      .filter((item) => item !== null);
  };

  const getInventoryList = () => {
    setLoading(true);
    getInventory({ page: pagination.currentPage })
      .then((res) => {
        let DATA = ParseInventoryList(res.data);
        let pages = [];
        for (let i = 1; i <= res.last_page; i++) {
          pages.push(i);
        }
        setPagination((prev) => {
          return {
            ...prev,
            pages,
          };
        });
        setData(DATA);
        // Apply search filter to the data
        const filteredData = filterContainersBySearch(DATA, searchQuery);
        setFilteredData(filteredData);
        // Set filter data for both tabs
        setFilter({ open: false, DATA, appliedFilters: {} });
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  const getInventoryLoadList = (noLoad) => {
    if (!noLoad) {
      setLoading(true);
    }

    getInventoryLoad({ page: pagination.currentPage, noLoad })
      .then((res) => {
        let DATA = res;
        let pages = [];
        for (let i = 1; i <= res.last_page; i++) {
          pages.push(i);
        }
        setPagination((prev) => {
          return {
            ...prev,
            pages,
          };
        });
        setData(DATA);
        // Apply search filter to the data
        const filteredData = filterContainersBySearch(DATA, searchQuery);
        setFilteredData(filteredData);
        // Set filter data for All tab as well
        setFilter({ open: false, DATA, appliedFilters: {} });
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  const getInventoryListNotLoading = () => {
    getInventory({ page: pagination.currentPage })
      .then((res) => {
        let DATA = ParseInventoryList(res.data);
        let pages = [];
        for (let i = 1; i <= res.last_page; i++) {
          pages.push(i);
        }
        setPagination((prev) => {
          return {
            ...prev,
            pages,
          };
        });
        setData(DATA);
        // Apply search filter to the data
        const filteredData = filterContainersBySearch(DATA, searchQuery);
        setFilteredData(filteredData);
        // Only set filter data for dropped tab
        if (activeTab === 'dropped') {
          setFilter({ open: false, DATA, appliedFilters: {} });
        }
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  React.useEffect(() => {
    // Update tableType based on activeTab
    setTableType(
      activeTab === 'dropped' ? 'inventoryTableDropped' : 'inventoryTable'
    );
    // Reset toggled state when tab changes to refresh Options component
    setToggled((prev) => !prev);
    // Reset filters when tab changes
    setFilter({
      open: false,
      DATA: [],
      appliedFilters: {},
    });
    getInventoryTableHeadList();
    activeTab === 'dropped' ? getInventoryList() : getInventoryLoadList();
  }, [pagination.currentPage, activeTab]);

  React.useEffect(() => {
    if (state.file) {
      setLoading(true);
      importInventory(state.file)
        .then((res) => {
          let DATA = ParseInventoryList(res);
          setData(DATA);
          const filteredData = filterContainersBySearch(DATA, searchQuery);
          setFilteredData(filteredData);
          // Set filter data for both tabs
          setFilter((f) => ({ ...f, DATA, appliedFilters: {} }));
          setLoading(false);
        })
        .catch((err) => {
          // notify(err, 'warning');
          SaveApiResMessage({
            title: 'Error',
            message: err,
            mode: 'warning',
          });
          setData([]);
          setFilteredData([]);
          // Only set filter data for dropped tab
          if (activeTab === 'dropped') {
            setFilter((f) => ({ ...f, DATA: [], appliedFilters: {} }));
          }
          setLoading(false);
        });
    }
  }, [state.file, notify]);

  const Del = (id) =>
    delInventory(id)
      .then((msg) => {
        // notify(msg);
        SaveApiResMessage({
          title: msg?.data?.messageHeader,
          message: msg,
          mode: 'success',
        });
        getInventory()
          .then((res) => {
            let DATA = ParseInventoryList(res.data);
            setData(DATA);
            const filteredData = filterContainersBySearch(DATA, searchQuery);
            setFilteredData(filteredData);
            // Only set filter data for dropped tab
            if (activeTab === 'dropped') {
              setFilter({ ...filter, DATA, appliedFilters: {} });
            }
            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning');
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
          });
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });

  const DelContainer = (id) =>
    delContainer(id)
      .then((msg) => {
        // notify(msg);
        SaveApiResMessage({
          title: msg?.data?.messageHeader,
          message: msg,
          mode: 'success',
        });
        getInventory()
          .then((res) => {
            let DATA = ParseInventoryList(res.data);
            setData(DATA);
            const filteredData = filterContainersBySearch(DATA, searchQuery);
            setFilteredData(filteredData);
            // Only set filter data for dropped tab
            if (activeTab === 'dropped') {
              setFilter({ ...filter, DATA, appliedFilters: {} });
            }
            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning')
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
          });
      })
      .catch((err) => {
        // notify(err, 'warning')
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  const DelContainerLoad = (id) =>
    delContainerLoad(id)
      .then((msg) => {
        // notify(msg);
        SaveApiResMessage({
          title: msg?.data?.messageHeader || 'Success',
          message: msg?.message || 'Container Deleted Successfully',
          mode: 'success',
        });
        getInventoryLoadList(true);
      })
      .catch((err) => {
        // notify(err, 'warning')
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });

  const deleteallDroped = () => {
    deleteAllDroppedContainersApi()
      .then((msg) => {
        // notify(msg);
        SaveApiResMessage({
          title: 'All Inventory Deleted',
          message: 'Inventory has been cleared successfully.',
          mode: 'success',
        });
        getInventory()
          .then((res) => {
            let DATA = ParseInventoryList(res.data);
            setData(DATA);
            const filteredData = filterContainersBySearch(DATA, searchQuery);
            setFilteredData(filteredData);
            // Only set filter data for dropped tab
            if (activeTab === 'dropped') {
              setFilter({ ...filter, DATA, appliedFilters: {} });
            }
            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning')
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
          });
      })
      .catch((err) => {
        // notify(err, 'warning')
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  const deleteallLoad = () => {
    deleteAllLoadContainersApi()
      .then((msg) => {
        // notify(msg);
        SaveApiResMessage({
          title: 'All Inventory Deleted',
          message: 'Inventory has been cleared successfully.',
          mode: 'success',
        });
        getInventory()
          .then((res) => {
            let DATA = ParseInventoryList(res.data);
            setData(DATA);
            const filteredData = filterContainersBySearch(DATA, searchQuery);
            setFilteredData(filteredData);
            // Only set filter data for dropped tab
            if (activeTab === 'dropped') {
              setFilter({ ...filter, DATA, appliedFilters: {} });
            }
            setLoading(false);
          })
          .catch((err) => {
            // notify(err, 'warning')
            SaveApiResMessage({
              title: 'Error',
              message: err,
              mode: 'warning',
            });
          });
      })
      .catch((err) => {
        // notify(err, 'warning')
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  // Handle delete all confirmation
  const handleDeleteAllConfirm = () => {
    if (showDeleteAllModal.deleteType === 'dropped') {
      deleteallDroped();
    } else if (showDeleteAllModal.deleteType === 'load') {
      deleteallLoad();
    }
    setShowDeleteAllModal({ show: false, deleteType: null });
  };

  // Handle delete all button click - show confirmation modal
  const handleDeleteAllClick = (deleteType) => {
    setShowDeleteAllModal({ show: true, deleteType });
  };

  const openPopUp = (item, containerId, gatedIn, gatedOut, container) => {
    noScroll();
    setState({
      ...state,
      edit: item,
      containerId: containerId,
      gatedIn: gatedIn,
      gatedOut: gatedOut,
      container,
    });
  };
  const openAppointment = (item, containerId, gatedIn, gatedOut, container) => {
    // Set flag to indicate navigation from Return Appointments
    sessionStorage.setItem('fromReturnAppointments', 'true');

    noScroll();
    setState({
      ...state,
      appointment: item,
      containerId: containerId,
      gatedIn: gatedIn,
      gatedOut: gatedOut,
      container,
    });

    // Clear flag after a short delay to allow component to read it
    setTimeout(() => {
      sessionStorage.removeItem('fromReturnAppointments');
    }, 100);
  };
  const openOptions = (tableTheadTitle) => {
    noScroll();
    setState({
      ...state,
      tableTheadTitle: tableTheadTitle,
    });
  };

  // const Update = (form, inventory_id, containers) => {
  //   for (let el in form) {
  //     if (!form[el]) {
  //       notify('Can not add, Please check fields.', 'warning');
  //       return;
  //     }
  //   }

  const Update = (form, container_id, containers) => {
    for (let el in form) {
      // if (!form[el]) {
      //   notify('Can not add, Please check fields.', 'warning');
      //   return;
      // }
    }
    return upInventory(form)
      .then((res) => {
        // notify('Updated Successfully.');
        SaveApiResMessage({
          title: 'Update Inventory',
          message: 'Updated Successfully.',
          mode: 'success',
        });
        getInventoryList();
        // Set filter data for both tabs
        setFilter({ ...filter, DATA, appliedFilters: {} });
        closePopup();
        // updateInventoriContainers(container_id, { containers }).then((res) => {
        // });
      })
      .catch((err) => {
        // notify(err, 'warning')
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  const updateContainer = (containerId, updateData) => {
    // notify('Updating container...');
    SaveApiResMessage({
      title: 'Info',
      message: 'Updating container...',
      mode: 'info',
    });

    // Make sure container_id is in the payload
    const payload = {
      ...updateData,
      container_id: containerId,
    };

    return updateInventoryLoadSslSpec(payload)
      .then((res) => {
        // notify('Container updated successfully!');
        SaveApiResMessage({
          title: res?.data?.messageHeader,
          message: 'Container updated successfully!',
          mode: 'success',
        });
        // Refresh the data based on active tab
        if (activeTab === 'dropped') {
          getInventoryList();
        } else {
          getInventoryLoadList(true);
        }
      })
      .catch((err) => {
        // notify(err?.message || 'Failed to update container', 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err?.message || 'Failed to update container',
          mode: 'warning',
        });
      });
  };

  const closePopup = () => {
    removeNoScroll();
    setState({ ...state, edit: null });
  };

  const handleExport = () => {
    setLoading(true);
    exportInventory()
      .then((res) => {
        setLoading(false);
        window.open(res, '_blank');
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };
  const getInventoryContainers = () => {
    removeNoScroll();
    let inventoryContainers = [];
    inventoryContainers.push({
      size: state.appointment.size,
      ssl: state.appointment.ssl,
      location: state.appointment.loc,
      lfd: formatDateTimeToUTC(state?.container.last_free_day),
      aptType: 'None',
      chassesType:
        state?.container.own_chases === 0
          ? 'Pool'
          : state?.container.own_chases === 1
          ? 'Own'
          : '',
      terminalApt: state?.container.return_appointment || 'No Apt.',
      name: state?.container.name || '',
      id: state?.container.id || null,
      chases: state?.container.chases || '',
      status: state?.container.status || null,
      gated_in: state?.container.gated_in
        ? formatDateTimeToUTC(state?.container.gated_in)
        : null,
      gated_out: state?.container.gated_out
        ? formatDateTimeToUTC(state?.container.gated_out)
        : null,
    });

    const queryParams = new URLSearchParams({
      apiData: JSON.stringify({
        size: Sizes.find(
          ({ label }) =>
            label ===
            (state?.appointment?.size ||
              `${state?.appointment?.specification?.size_type}`)
        )?.value,
        ssl: SSLs.find(
          ({ label }) =>
            label ===
            (state?.appointment?.ssl || state?.container?.company?.name)
        )?.value,
        containerId: state?.containerId,
        cabinId: state.container?.cabinId,
      }),
      containerData: encodeURIComponent(
        JSON.stringify([inventoryContainers[0]])
      ),
    }).toString();

    // SaveData({ apptsQueryParams: queryParams });

    if (activeTab === 'all') {
      history.push(
        `/inventory/emptyAll/appointments?${queryParams}&cabinId=${state?.appointment?.cabinId}`
      );
    } else {
      history.push(
        `/inventory/emptyDropped/appointments?${queryParams}&cabinId=${state?.appointment?.cabinId}`
      );
    }
  };

  useEffect(() => {
    state?.appointment && getInventoryContainers();
  }, [state?.appointment]);

  return (
    <PageContainer
      title="Your Empty"
      icon="yourInventory"
      mainPage={true}
      minWidth="auto"
      rightContent={
        <AddButton
          title={activeTab === 'dropped' ? 'Add Empty' : 'Add Load'}
          onClick={() => {
            setOpenAdd(true);
          }}
        />
      }>
      {/* <div id="inventoryEmpty" className={cls.content}> */}
      {state.edit && (
        <Edit
          data={state.edit}
          containerId={state.containerId}
          gatedIn={state.gatedIn}
          gatedOut={state.gatedOut}
          container={state.container}
          Close={closePopup}
          Update={Update}
        />
      )}
      <div className="flex flex-col lg:flex-row gap-3 justify-between lg:items-center my-5">
        {loadoutEnable === '1' ? (
          <PageContainerTabs
            titlesLinks={[
              { title: 'Dropped', pushAddress: 'dropped' },
              { title: 'All', pushAddress: 'all' },
            ]}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            baseAddress="/inventory/empty/"
          />
        ) : (
          <span></span>
        )}
        <div className="flex flex-wrap flex-col sm:flex-row gap-1 lg:gap-3 py-2 justify-between w-full lg:w-auto lg:justify-start">
          <SearchContainer
            width={'264px'}
            placeholder="Search Container or City"
            setContainerName={setSearchQuery}
            setPage={() => {}}
          />

          {activeTab === 'dropped' && (
            <IconButton
              text="Delete All"
              icon="deleteIcon"
              color="#FF0000"
              onClick={() => {
                handleDeleteAllClick('dropped');
              }}
            />
          )}
          <IconButton
            ref={mainToggleButtonRef}
            active={options.open}
            text="Column"
            icon="options"
            color="#131517"
            onClick={() => {
              console.log(
                'Main button clicked, current options.open:',
                options.open
              );
              // Don't override tableType here - it's already set based on activeTab
              setOptions(
                options.open ? { open: false } : { ...options, open: true }
              );
              setToggled(true);
              setFilter({ ...filter, open: false });
            }}
          />
          <IconButton
            active={filter.open || hasAppliedFilters()}
            text="Filter"
            icon="filter"
            textStyle={{
              color: '#131517',
            }}
            onClick={() => {
              setFilter({ ...filter, open: filter.open ? false : true });
              setOptions({ ...options, open: false });
            }}
          />
          <IconButton
            text="Export XLSX"
            icon="exportXLSXIcon"
            color="#131517"
            onClick={handleExport}
          />
        </div>
      </div>

      <CustomFilter
        filtersList={['size', 'ssl', 'loc']}
        noTitleAndIcon={true}
        filter={filter}
        setFilter={setFilter}
        DATA={DATA || []}
        activeTab={activeTab}
      />

      {hasAppliedFilters() && (
        <div className="relative z-99 w-full bg-white rounded-lg items-center flex flex-wrap gap-2  p-3 ">
          <span className="text-sm">Filtered by:</span>
          {Object.entries(filter.appliedFilters)
            .filter(([key, value]) => value)
            .map(([key, value]) => {
              return (
                <CustomBadge
                  key={key}
                  text={value?.label}
                  onClick={() => {
                    const newFilters = { ...filter.appliedFilters };
                    delete newFilters[key];

                    setFilter({
                      ...filter,
                      appliedFilters: newFilters,
                    });
                  }}
                />
              );
            })}
        </div>
      )}
      <Options
        noTitleAndIcon={true}
        options={options}
        tableType={tableType}
        setTableType={setTableType}
        tableTheadTitle={tableTheadTitle || []}
        toggled={toggled}
        setOptions={setOptions}
        mainToggleButtonRef={mainToggleButtonRef}></Options>

      <Modal
        noX
        minWidth="unset"
        notClose={true}
        show={openAdd}
        setShow={setOpenAdd}
        icon={'addInventoryIcon'}
        title={activeTab === 'dropped' ? 'Add Empty' : 'Add Load'}
        rightContent={
          <div className={cls.cardHeader}>
            <div className={cls.row}>
              <span className={cls.title}>Import</span>
              <label className={cls.import}>
                <input
                  type="file"
                  style={{ display: 'none' }}
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  onChange={(e) => {
                    setState({ ...state, file: e.target.files[0] });
                    e.target.value = null;
                    setOpenAdd(false);
                  }}
                />
                {/* <GetAppRounded /> */}
                <span>XLSX</span>
              </label>
            </div>
          </div>
        }>
        <div className={cls.addContainerSection}>
          <Add
            notify={notify}
            setOpenAdd={setOpenAdd}
            getInventoryList={getInventoryList}
            getInventoryLoadList={getInventoryLoadList}
            activeTab={activeTab}
            setData={(res) => {
              let DATA = ParseInventoryList(res);
              setData(DATA);
              const filteredData = filterContainersBySearch(DATA, searchQuery);
              setFilteredData(filteredData);
              // Set filter data for both tabs
              setFilter({ ...filter, DATA, appliedFilters: {} });
            }}
          />
        </div>
      </Modal>

      {loading ? (
        <div className="mt-16">
          <LoadingV2 />
        </div>
      ) : (
        <List
          DATA={
            searchQuery
              ? filteredData
              : filter.DATA !== undefined
              ? filter.DATA
              : DATA
          }
          Del={Del}
          DelContainer={DelContainer}
          DelContainerLoad={DelContainerLoad}
          deleteallDroped={deleteallDroped}
          deleteallLoad={deleteallLoad}
          Edit={openPopUp}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          Appointment={openAppointment}
          formatDateTimeToUTC={formatDateTimeToUTC}
          getInventoryList={getInventoryList}
          getInventoryListNotLoading={getInventoryListNotLoading}
          currentPage={pagination.currentPage}
          mptyTrackingEnable={mptyTrackingEnable}
          loadoutEnable={loadoutEnable}
          enable_appointments={enable_appointments}
          tableTheadTitle={tableTheadTitle}
          Sizes={Sizes}
          SSLs={SSLs}
          updateContainer={updateContainer}
        />
      )}
      <Pagination pagination={pagination} setPagination={setPagination} />
      {/* </div> */}

      {/* Delete All Confirmation Modal */}
      <Modal
        minWidth="unset"
        noX
        show={showDeleteAllModal.show}
        children={
          <span className="mt-6 text-center w-full md:min-w-xl">
            Are you sure you want to delete all{' '}
            {showDeleteAllModal.deleteType === 'dropped' ? 'dropped' : 'load'}{' '}
            containers?
          </span>
        }
        submitText={'Yes, Delete All'}
        icon={'deleteIcon'}
        title={`Delete All ${
          showDeleteAllModal.deleteType === 'dropped' ? 'Dropped' : 'Load'
        } Containers`}
        setShow={(value) => {
          setShowDeleteAllModal({
            show: value,
            deleteType: showDeleteAllModal.deleteType,
          });
        }}
        submit={handleDeleteAllConfirm}
        loadingbutton={false}
      />
    </PageContainer>
  );
};
